import { useState } from 'react';

interface UseProductPreferenceProps {
  contact_id: string;
  preference: string;
}

type Status = 'idle' | 'loading' | 'success' | 'error';

interface UseProductPreferenceReturn {
  submitPreference: (data: UseProductPreferenceProps) => Promise<boolean>;
  status: Status;
  error: string | null;
  isLoading: boolean;
  isSuccess: boolean;
  reset: () => void;
}

export const useProductPreference = (): UseProductPreferenceReturn => {
  const [status, setStatus] = useState<Status>('idle');
  const [error, setError] = useState<string | null>(null);

  const submitPreference = async (
    data: UseProductPreferenceProps
  ): Promise<boolean> => {
    setStatus('loading');
    setError(null);

    try {
      const response = await fetch('/api/sendProductPreference', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to submit preference');
      }

      setStatus('success');

      return true;
    } catch (err) {
      const errorMessage =
        err instanceof Error ? err.message : 'An error occurred';
      setError(errorMessage);
      setStatus('error');

      return false;
    }
  };

  const reset = () => {
    setStatus('idle');
    setError(null);
  };

  return {
    submitPreference,
    status,
    error,
    isLoading: status === 'loading',
    isSuccess: status === 'success',
    reset,
  };
};
